import { useEffect, useState } from 'react';
import AboutService from '../API/AboutService';
import { baseURL } from '../index';

// Список иконок-ссылок соцсетей (редактируются в админке, раздел "Соцсети").
// Иконки маленькие и показываются в натуральном размере - обертка задает
// только отступы/ховер, не размеры (растянутые иконки мылятся)
const SocialIcons = () => {
    const [links, setLinks] = useState([]);

    useEffect(() => {
        AboutService.getAbout()
            .then(response => setLinks(response.data.social_links))
            .catch(error => console.log('Не удалось загрузить соцсети: ' + error));
    }, []);

    return (
        <>
            {links.map((link, index) => (
                <a key={index} href={link.url} target='_blank' rel='noreferrer'>
                    <img src={baseURL + link.icon_url} alt={link.title} />
                </a>
            ))}
        </>
    );
}

export default SocialIcons;
